import SakuraEffectComp from "./SakuraEffectComp";

const HeroComp = () => {
  const movePage = (link) => {
    window.open(link, "_blank");
  };

  return (
    <>
      {/* HERO */}
      <section className="hero">
        <SakuraEffectComp />

        {/* BACKGROUND IMAGE DESKTOP */}
        <div className="hero-bg"></div>

        <div className="hero-content">
          {/* LEFT */}
          <div className="hero-left">
            <h1
              className="mitra-title"
              style={{
                fontSize: "58px",
                lineHeight: "1.1",
                marginBottom: "24px",
                color: "#111",
                fontWeight: 800,
              }}
            >
              Buat Website Undangan
              <br />
              <span style={{ color: "#ff0a8a" }}>
                Unlimited & Tanpa Masa Aktif
              </span>
            </h1>

            <p
              className="mitra-desc"
              style={{
                fontSize: "18px",
                lineHeight: "32px",
                color: "#666",
                marginBottom: "40px",
                maxWidth: "580px",
              }}
            >
              Platform untuk membuat website undangan digital dengan mudah,
              cepat, modern, dan tanpa batas.
            </p>

            {/* BUTTON */}
            <div className="hero-buttons">
              <button
                className="btn-primary"
                onClick={() => movePage("https://app.idinvitebook.com/login")}
              >
                Buat Undangan
              </button>

              <button
                className="btn-secondary"
                onClick={() =>
                  movePage("https://www.youtube.com/watch?v=RaVHs9ZT5f4&t=3s")
                }
              >
                Lihat Demo
              </button>
            </div>

            {/* TRUST */}
            <div className="trust-users mt-4">
              <div className="avatars">
                <img src="https://i.pravatar.cc/40?img=1" />
                <img src="https://i.pravatar.cc/40?img=2" />
                <img src="https://i.pravatar.cc/40?img=3" />
                <img src="https://i.pravatar.cc/40?img=4" />
              </div>

              <p className="pt-3">
                <strong>1000+</strong> pengguna mempercayai idInviteBook
              </p>
            </div>
          </div>

          {/* IMAGE MOBILE */}
          <div className="hero-mobile-image">
            {/* <img
              src="https://image.invb.my.id/64b9058e88cc900dc65eb486/1777422372132-idinvitebookdevices-1.png"
              alt="idinvitebook"
            /> */}
          </div>
        </div>
      </section>

      {/* STYLE */}
      <style>
        {`
          .hero {
            width: 100%;
            min-height: 100vh;
            position: relative;
            overflow: hidden;
    
            display: flex;
            align-items: center;

            padding: 120px 40px 80px;
          }

          /* BACKGROUND IMAGE */
          .hero-bg {
            position: absolute;
            top: 50%;
            right: -5%;

            transform: translateY(-50%);

            width: 58%;
            height: 100%;

            // background-image: url("https://image.invb.my.id/64b9058e88cc900dc65eb486/1777422372132-idinvitebookdevices-1.png");
            background-repeat: no-repeat;
            background-position: center right;
            background-size: contain;

            z-index: 1;
            pointer-events: none;
          }

          /* CONTENT */
          .hero-content {
            width: 100%;
            max-width: 1350px;
            margin: 0 auto;

            position: relative;
            z-index: 2;
          }

          /* LEFT */
          .hero-left {
            max-width: 620px;
          }

          /* BUTTONS */
          .hero-buttons {
            display: flex;
            gap: 16px;
            flex-wrap: wrap;
          }

          .btn-primary {
            border: none;
            background: #ff0a8a;
            color: #fff;

            padding: 15px 28px;
            border-radius: 16px;

            font-size: 15px;
            font-weight: 700;

            cursor: pointer;
            transition: 0.3s;

            box-shadow: 0 12px 24px rgba(255,10,138,0.2);
          }

          .btn-primary:hover {
            background: #ea007d;
            transform: translateY(-2px);
          }

          .btn-secondary {
            border: 1px solid #eee;
            background: #fff;
            color: #222;

            padding: 15px 26px;
            border-radius: 16px;

            font-size: 15px;
            font-weight: 700;

            cursor: pointer;
            transition: 0.3s;
          }

          .btn-secondary:hover {
            border-color: #ff0a8a;
            color: #ff0a8a;
          }

          /* TRUST */
          .trust-users {
            display: flex;
            align-items: center;
            gap: 18px;
            flex-wrap: wrap;
          }

          .avatars {
            display: flex;
            align-items: center;
          }

          .avatars img {
            width: 46px;
            height: 46px;
            border-radius: 50%;
            object-fit: cover;
            border: 3px solid #fff;
            margin-left: -10px;
          }

          .avatars img:first-child {
            margin-left: 0;
          }

          .trust-users p {
            color: #555;
            margin: 0;
          }

          /* MOBILE IMAGE */
          .hero-mobile-image {
            display: none;
          }

          /* TABLET */
          @media (max-width: 991px) {
            .hero {
              padding: 120px 24px 80px;
            }

            .hero-bg {
              width: 52%;
              right: -10%;
            }

            .mitra-title {
              font-size: 48px !important;
            }
          }

          /* MOBILE */
          @media (max-width: 768px) {
            .hero {
              min-height: auto;
              padding: 110px 20px 70px;
            }

            /* HIDE BACKGROUND */
            .hero-bg {
              display: none;
            }

            /* SHOW IMAGE */
            .hero-mobile-image {
              display: block;
              width: 100%;
              margin-bottom: 40px;
              text-align: center;
            }

            .hero-mobile-image img {
              width: 100%;
              max-width: 520px;
              object-fit: contain;
            }

            .hero-content {
              display: flex;
              flex-direction: column;
            }

            /* IMAGE TOP */
            .hero-mobile-image {
              order: -1;
            }

            .hero-left {
              max-width: 100%;
              text-align: center;
            }

            .mitra-title {
              font-size: 40px !important;
              line-height: 1.2 !important;
            }

            .mitra-desc {
              font-size: 17px !important;
              line-height: 30px !important;
              margin-inline: auto;
            }

            .hero-buttons {
              justify-content: center;
            }

            .trust-users {
              justify-content: center;
              text-align: center;
            }
          }

          /* SMALL MOBILE */
          @media (max-width: 480px) {
            .hero {
              padding: 100px 16px 60px;
            }

            .mitra-title {
              font-size: 34px !important;
            }

            .mitra-desc {
              font-size: 16px !important;
              line-height: 28px !important;
            }

            .btn-primary,
            .btn-secondary {
              width: 100%;
            }

            .hero-buttons {
              flex-direction: column;
            }

            .avatars img {
              width: 42px;
              height: 42px;
            }
          }
        `}
      </style>
    </>
  );
};

export default HeroComp;
